module.exports = __webpack_public_path__ + "img/step1a.5ee4dd0b.svg";